import { Box, BoxList, Text } from '@factorialco/deprecated-design-system'
import { isEmpty } from 'lodash'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import ArchivedWorkAreaItem from 'modules/locations/components/ArchivedWorkAreaItem'
import { useUnArchiveWorkArea } from 'modules/locations/hooks/useUnArchiveWorkArea'
import { WorkAreaNode } from 'modules/locations/hooks/useWorkAreas'

interface Props {
  items: NonNullable<WorkAreaNode>[]
}

const ArchivedWorkAreas = ({ items }: Props) => {
  const { unArchiveWorkArea } = useUnArchiveWorkArea()

  const unarchiveWorkArea = (workArea: WorkAreaNode) => {
    if (workArea) unArchiveWorkArea({ id: workArea.id })
  }

  const archivedItems = () =>
    items.map((workArea) => (
      <ArchivedWorkAreaItem
        key={workArea.id}
        workArea={workArea}
        unarchiveWorkArea={unarchiveWorkArea}
      />
    ))

  const emptyArchivedWorkAreas = () => (
    <Box width="full" paddingY="s48" textAlign="center">
      <Text size="300" weight="medium">
        {i18n.t('settings.locations.location.work_areas.archived.empty_message')}
      </Text>
    </Box>
  )

  return <BoxList>{!isEmpty(items) ? archivedItems() : emptyArchivedWorkAreas()}</BoxList>
}

export default observer(ArchivedWorkAreas)
